import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrganisationTaskTypesComponent } from './organisation-task-types.component';
import { TableModule } from 'primeng';

const routes: Routes = [
  {
    path: '',
    component: OrganisationTaskTypesComponent,
    data: { title: 'Organisation Task Types' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganisationTaskTypesRoutingModule {}

@NgModule({
  imports: [
    OrganisationTaskTypesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [OrganisationTaskTypesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrganisationTaskTypesModule {}
